import React, { useEffect, useState } from 'react';
function getTargetTime(): number {
  const stored = localStorage.getItem('hae_countdown_target');
  if (stored) {
    const target = parseInt(stored, 10);
    if (target > Date.now()) return target;
  }
  const target = Date.now() + 24 * 60 * 60 * 1000;
  localStorage.setItem('hae_countdown_target', target.toString());
  return target;
}
function formatTime(ms: number): {
  hours: string;
  minutes: string;
  seconds: string;
} {
  if (ms <= 0) return {
    hours: '00',
    minutes: '00',
    seconds: '00'
  };
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return {
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0')
  };
}
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState<number>(() => {
    return Math.max(0, getTargetTime() - Date.now());
  });
  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = Math.max(0, getTargetTime() - Date.now());
      setTimeLeft(remaining);
      if (remaining <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const {
    hours,
    minutes,
    seconds
  } = formatTime(timeLeft);
  return <div className="flex items-center justify-center gap-2" role="timer" aria-label="Tiempo restante de la oferta" data-id="element-30">
      <TimeBlock value={hours} label="hrs" data-id="element-31" />
      <span className="text-amber-500 text-xl font-bold mt-[-12px]" data-id="element-32">:</span>
      <TimeBlock value={minutes} label="min" data-id="element-33" />
      <span className="text-amber-500 text-xl font-bold mt-[-12px]" data-id="element-34">:</span>
      <TimeBlock value={seconds} label="seg" data-id="element-35" />
    </div>;
}
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-36">
      <div className="bg-white/5 border border-white/10 rounded-lg px-3 py-2 min-w-[52px] text-center" data-id="element-37">
        <span className="text-2xl font-bold text-white tabular-nums" data-id="element-38">
          {value}
        </span>
      </div>
      <span className="text-[10px] uppercase tracking-wider text-gray-500 mt-1" data-id="element-39">
        {label}
      </span>
    </div>;
}